import { render, staticRenderFns } from "./SuggestionConclusion.vue?vue&type=template&id=12d1b9d6&scoped=true"
import script from "./SuggestionConclusion.vue?vue&type=script&lang=ts"
export * from "./SuggestionConclusion.vue?vue&type=script&lang=ts"
import style0 from "./SuggestionConclusion.vue?vue&type=style&index=0&id=12d1b9d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d1b9d6",
  null
  
)

export default component.exports